import 'notyf/notyf.min.css';
import React, { useEffect, useState } from 'react';
import '../../assets/css/toast.scss';

export default function Toast({ icon, text }) {
  const [showNotif, setShowNotif] = useState(false);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (!text) return;
    if (timer) clearTimeout(timer);
    const timer1 = setTimeout(() => setShowNotif(false), 3000);
    setTimer(timer1);
    setShowNotif(true);
  }, [text]);

  return showNotif && text ? (
    <div className="notyf__toast notyf__toast--lower h2-color-bg">
      <div className="notyf__wrapper">
        <div className="notyf__message">
          <img alt='toastimg' src={icon} height="40" width="30" />
          <span className="h2-color-text ml-3">{text}</span>
        </div>
      </div>
    </div>
  ) : null;
}
